export interface IDocumentKindListSelectorDialogCondition {
}

export function instanceOfIDocumentKindListSelectorDialogCondition(instance: any): instance is IDocumentKindListSelectorDialogCondition {
  return !!instance;
}
